type Props = {
  logo: string;
  name?: string;
};

export const BrandLogoCard = ({ logo, name = "Partner brand" }: Props) => {
  return (
    <div className="flex items-center justify-center h-[96px] lg:h-[148px] rounded-[16px] lg:rounded-[20px] bg-white shadow-[0_4px_24px_rgba(0,0,0,0.06)]">
      {/* Logo sits in a circle; contain (not cover) so wide wordmarks aren't cropped */}
      <div className="flex items-center justify-center w-[68px] h-[68px] lg:w-[104px] lg:h-[104px] rounded-full overflow-hidden bg-white border-[1px] border-[#EEEEEE] shadow-[0_2px_10px_rgba(0,0,0,0.06)]">
        <img src={logo} alt={name} loading="lazy" className="w-full h-full object-contain p-[10px] lg:p-[14px]" />
      </div>
    </div>
  );
};
